/**
 * Контент справки для страницы устройств.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'devices',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.devices.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.devices.overview',

  // Идентификатор связанного тура
  tourId: 'devices-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'view-route',
      questionKey: 'help.pages.devices.faq.viewRoute.question',
      answerKey: 'help.pages.devices.faq.viewRoute.answer',
    },
    {
      id: 'device-offline',
      questionKey: 'help.pages.devices.faq.deviceOffline.question',
      answerKey: 'help.pages.devices.faq.deviceOffline.answer',
    },
    {
      id: 'rename-device',
      questionKey: 'help.pages.devices.faq.renameDevice.question',
      answerKey: 'help.pages.devices.faq.renameDevice.answer',
    },
    {
      id: 'create-group',
      questionKey: 'help.pages.devices.faq.createGroup.question',
      answerKey: 'help.pages.devices.faq.createGroup.answer',
    },
    {
      id: 'marker-colors',
      questionKey: 'help.pages.devices.faq.markerColors.question',
      answerKey: 'help.pages.devices.faq.markerColors.answer',
    },
    {
      id: 'show-geozones',
      questionKey: 'help.pages.devices.faq.showGeozones.question',
      answerKey: 'help.pages.devices.faq.showGeozones.answer',
    },
    {
      id: 'expand-details',
      questionKey: 'help.pages.devices.faq.expandDetails.question',
      answerKey: 'help.pages.devices.faq.expandDetails.answer',
    },
    {
      id: 'view-chart',
      questionKey: 'help.pages.devices.faq.viewChart.question',
      answerKey: 'help.pages.devices.faq.viewChart.answer',
    },
    {
      id: 'measure-distance',
      questionKey: 'help.pages.devices.faq.measureDistance.question',
      answerKey: 'help.pages.devices.faq.measureDistance.answer',
    },
    {
      id: 'analyze-fuel',
      questionKey: 'help.pages.devices.faq.analyzeFuel.question',
      answerKey: 'help.pages.devices.faq.analyzeFuel.answer',
    },
    {
      id: 'city-speed-limit',
      questionKey: 'help.pages.devices.faq.citySpeedLimit.question',
      answerKey: 'help.pages.devices.faq.citySpeedLimit.answer',
    },
    {
      id: 'guard-vehicle',
      questionKey: 'help.pages.devices.faq.guardVehicle.question',
      answerKey: 'help.pages.devices.faq.guardVehicle.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    mapToolbar: 'help.tooltips.devices.mapToolbar',
    search: 'help.tooltips.devices.search',
    filters: 'help.tooltips.devices.filters',
    groups: 'help.tooltips.devices.groups',
    deviceCard: 'help.tooltips.devices.deviceCard',
    routePanel: 'help.tooltips.devices.routePanel',
  },

  // Связанные туры (для раздела "Другие обзоры")
  relatedTours: ['onboarding', 'geozones-page', 'reports-page'],
}
